fragment ContactBlockFragment on contactBlock_Entry {
  typeHandle
  heading
  sections: contactRows {
    ... on contactRowsBlock_Entry {
      id
      heading
      body
      telephone
      phoneDescription
      email
    }
  }
}
